import { render, staticRenderFns } from "./ListSeguradoraPage.vue?vue&type=template&id=ea7dc116"
import script from "./ListSeguradoraPage.vue?vue&type=script&lang=js"
export * from "./ListSeguradoraPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports